// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// vip官网-网页取证-新增
export const _saveWebpage = (params) => {
    return postRequest('/evidenceWebpage/save', params)
}
// 分页获取
export const _getByPage = (params) => {
    return getRequest('/evidenceWebpage/getByPage', params)
}
// 更新取证标题
export const _updateTitle = (params) => {
    return postRequest('/evidenceWebpage/updateTitle', params)
}
// 网页取证核验接口
export const _getVerifyOperatio = (params) => {
    return getRequest('/verifyOperation/get', params)
}
// 重新取证
export const _getresave = (params) => {
    return postRequest('/evidenceWebpage/resave', params)
}
// 天平链核验数据
export const _getTianPing = (params) => {
    return postRequest('/getTianPing', params)
}